// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__AqjzG","transparent":"Backdrop_transparent__75+eM"};